module.exports = __webpack_public_path__ + "img/20200502_203758.0da29980.jpg";